import { Box, Chip, Tooltip } from '@mui/material'
import { AdCampaignData, Brand } from '@promoboxx/graphql-gateway-types'
import I18n from 'i18n-js'
import { memo } from 'react'
import { useSelector } from 'react-redux'

import partition from '@src/lib/partition'
import { brandsForCurrentRetailerAccountSelector } from '@src/stores/app/selectors'
import { availablePaidAdsSelector } from '@src/stores/paidAds/selectors'

const UnclaimedAdsChip: React.FC<
  React.PropsWithChildren<{ brandFilter?: string }>
> = (props) => {
  const paidAds = useSelector(availablePaidAdsSelector)
  const brands = useSelector(brandsForCurrentRetailerAccountSelector)
  const [picBrandsIds, nonPicBrandsIds] = partition(
    brands,
    (brand: Brand) => brand.community === true,
    (brand: Brand) => String(brand.id), // TODO: ts says brand.id is string but its actually number
  )
  const unclaimedAdsCount = paidAds.filter((ad: AdCampaignData) => {
    switch (props.brandFilter) {
      case 'brand':
        return nonPicBrandsIds.includes(ad.brand_id)
      case 'industry':
        return picBrandsIds.includes(ad.brand_id)
      default:
        return true
    }
  }).length

  if (unclaimedAdsCount === 0) {
    return null
  }

  return (
    <Tooltip title={I18n.t('content.unclaimedAds')} placement="top">
      <Box sx={{ display: 'inline-block' }}>
        <Chip color="error" size="small" label={unclaimedAdsCount} />
      </Box>
    </Tooltip>
  )
}

export default memo(UnclaimedAdsChip)
